// 以下に app/frontend/js 配下のスクリプトをimportする
import { Application } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

Turbo.session.drive = false

import '@fortawesome/fontawesome-free/css/all.css';
import 'bootstrap';

//scss import
import '@/stylesheets/admin.scss';
import 'hint.css';

//js import

// AdminLTE
import 'admin-lte';
import 'admin-lte/dist/css/adminlte.min.css';
import 'admin-lte/dist/js/adminlte.min.js';

// ActionText
import "@rails/actiontext";
import "trix";
Trix.config.lang.urlPlaceholder = "https://www.example.com（https部分も入力してください）";

// Stimulus controllers import
import { CancelPurchaseContractsController } from './cancel-purchase-contracts-controller.js';
import { CsvShiftjisSettingController } from './csv-shiftjis-setting-controller.js';
import { DirectUploadController } from './direct-uploader-controller.js';
import { ExportCsvController } from './export-csv-controller.js';
import { FormCheckboxController } from './form-checkbox-controller.js';
import { FormTermController } from './form-term-controller.js';
import { ImageFieldsController } from './image-fields-controller.js';
import { NftAccessController } from './nft-access-controller.js';
import { PaidPurchaseContractsController } from './paid-purchase-contracts-controller.js';
import { SiteStatisticsController } from './site-statistics-controller.js';
import { ZenginController } from './zengin-controller.js';
import { RewardModalController } from './reward-modal-controller.js';

// Start Stimulus application once
const application = Application.start();

// Register all controllers
application.register("direct-upload", DirectUploadController);
application.register("form-term", FormTermController);
application.register("cancel-purchase-contracts", CancelPurchaseContractsController);
application.register("csv-shiftjis-setting", CsvShiftjisSettingController);
application.register("export-csv", ExportCsvController);
application.register("form-checkbox", FormCheckboxController);
application.register("image-fields", ImageFieldsController);
application.register("nft-access", NftAccessController);
application.register("paid-purchase-contracts", PaidPurchaseContractsController);
application.register("site-statistics", SiteStatisticsController);
application.register("zengin", ZenginController);
application.register("reward-modal", RewardModalController);
